module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400.2248542.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-brands-400.woff
// module id = NBd9
// module chunks = 0